import React, { useState, useEffect } from "react";
import { axiosV2 } from "../../../utils/BasicAuthAPI";
import moment from "moment";
import "../audit.css";
import {
  Modal,
  Form,
  Input,
  Select,
  DatePicker,
  Button,
  message,
  Typography,
  Col,
  Row,
} from "antd";
import liracrypt from "../../Liracrypt/liracrypt";
import ApiErrorComp from "../../ApiErrorComp/ApiErrorComp";
import SessionError from "../../ApiErrorComp/SessionError";

const SearchAudit = (props) => {
  const [state, setState] = useState({
    visible: false,
    disabledBtn: false,
  });
  const [AuditLines, setAuditLines] = useState({ loaded: false, data: [] });
  const [AuditType, setAuditType] = useState({ loaded: false, data: [] });
  const [AuditSubType, setAuditSubType] = useState({ loaded: false, data: [] });
  const [AuditUsers, setAuditUsers] = useState({ loaded: false, data: [] });
  const [form] = Form.useForm();
  const [loginError, setLoginError] = useState(false);

  const onFinish = (values) => {
    setState({ ...state, disabledBtn: true });

    const reqDat = {
      ...values,
      AuditDt: values["audDt"] ? values["audDt"].format("YYYY/MM/DD") : null,
      TGT: "ALL",
      From: values["Search"] ? values["Search"][0].format("YYYY/MM/DD") : null,
      To: values["Search"] ? values["Search"][1].format("YYYY/MM/DD") : null,
    };

    liracrypt
      .get("/audit/session", reqDat)
      .then((res, req) => {
        let data = res.data;
        // const msg = data["Message"] ? data["Message"] : "Successfully Added!";
        // message.success(msg, 4)
        setState({ ...state, disabledBtn: false });
        // that.formRef.current.resetFields();
        props.sendBackData(data, {
          TYP: values["typ"],
          SUBTYP: values["subTyp"],
          LID: values["lid"],
          TGT: "all",
          Team: values["tean"],
          Auditor: values["auditor"],
          Auditee: values["auditee"],
          Status: values["status"],
          From: values["Search"]
            ? values["Search"][0].format("YYYY/MM/DD")
            : null,
          To: values["Search"]
            ? values["Search"][1].format("YYYY/MM/DD")
            : null,
        });
      })
      .catch(function (error) {
        message.error("ERROR: Unable to add!!", 2);
        console.log("Error****: fetch calendar", error);
        setState({ ...state, disabledBtn: false });
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            ApiErrorComp(error.response.status);
          } else {
            setLoginError(true);
          }
        }
      });
  };

  const fetchLine = () => {
    liracrypt
      .get("/mdict", {
        typ: "Line",
        subTyp: "idame",
      })
      .then((res, req) => {
        let data = res.data;
        const keys = Object.keys(data["data"]);
        let resData = keys.map((key) => {
          return { id: key, name: data["data"][key] };
        });
        resData.splice(0, 0, { id: "ALL", name: "All" });

        setAuditLines({ loaded: true, data: resData });
      })
      .catch(function (error) {
        console.log("Error****: fetch Line", error);
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            // ApiErrorComp(error.response.status);
          } else {
            setLoginError(true);
          }
        }
      });
  };
  const fetchType = () => {
    liracrypt
      .get("/mdict", {
        typ: "AuditTypes",
        subTyp: "idame",
      })
      .then((res, req) => {
        let data = res.data;
        const resData = data["data"].map((obj) => {
          const k = Object.keys(obj)[0];
          return { id: k, name: obj[k] };
        });
        setAuditType({ loaded: true, data: resData });
      })
      .catch(function (error) {
        console.log("Error****: fetch type", error);
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            // ApiErrorComp(error.response.status);
          } else {
            setLoginError(true);
          }
        }
      });
  };
  const fetchSubType = (reset) => {
    const typ = form.getFieldValue("TYP");
    form.setFieldsValue({
      ...form.getFieldsValue([
        "TYP",
        "LID",
        "Status",
        "Auditor",
        "Auditee",
        "Team",
        "AuditDt",
        "Search",
      ]),
      SUBTYP: null,
    });
    liracrypt
      .get("/mdict", {
        typ: "AuditTypes",
        subTyp: "treeData",
        queryKey: typ,
      })
      .then((res, req) => {
        let data = res.data;
        const subTyp = data["data"][typ] ? data["data"][typ] : [];
        console.log(subTyp);
        setAuditSubType({ loaded: true, data: subTyp });
      })
      .catch(function (error) {
        console.log("Error****: fetch subtype", error);
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            // ApiErrorComp(error.response.status);
          } else {
            setLoginError(true);
          }
        }
      });
  };
  const fetchUser = () => {
    liracrypt
      .get("/mdict", {
        typ: "User",
        subTyp: "idame",
      })
      .then((res, req) => {
        let data = res.data;
        const keys = Object.keys(data["data"]);
        let resData = keys.map((key) => {
          return { id: key, name: data["data"][key] };
        });
        resData.splice(0, 0, { id: "ALL", name: "All" });
        setAuditUsers({ loaded: true, data: resData });
      })
      .catch(function (error) {
        console.log("Error****: fetch user", error);
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            // ApiErrorComp(error.response.status);
          } else {
            setLoginError(true);
          }
        }
      });
  };

  useEffect(() => {
    if (props.defaultValues) {
      form.setFieldsValue({
        ...props.defaultValues,
        Search: [
          props.defaultValues.From
            ? moment(props.defaultValues.From, "YYYY/MM/DD")
            : null,
          props.defaultValues.To
            ? moment(props.defaultValues.To, "YYYY/MM/DD")
            : null,
        ],
      });
      if (props.defaultValues["TYP"]) {
        fetchSubType(true);
      }
    }
    if (props.AuditLines) {
      setAuditLines({
        loaded: true,
        data: [{ id: "ALL", name: "All" }, ...props.AuditLines],
      });
    }
    if (props.AuditType) {
      setAuditType({ loaded: true, data: props.AuditType });
    }
    if (props.AuditUsers) {
      setAuditUsers({
        loaded: true,
        data: [{ id: "ALL", name: "All" }, ...props.AuditUsers],
      });
    }
    
  }, [props]);

  useEffect(() => {
    if (props.defaultValues["SUBTYP"] && form) {
      const typ = form.getFieldValue("TYP");
      form.setFieldsValue({
        ...form.getFieldsValue([
          "TYP",
          "LID",
          "Status",
          "Auditor",
          "Auditee",
          "Team",
          "AuditDt",
          "Search",
        ]),
        SUBTYP:
          typ === props.defaultValues["TYP"]
            ? props.defaultValues["SUBTYP"]
            : null,
      });
    }
  }, [AuditSubType]);

  const modelCloseHandler = () => {
    setState({ visible: false, selectedEvent: null });
  };

  return (
    <>
      <SessionError visible={loginError} />
      <div className="AuditSection CreateAudit" style={{ padding: "10px" }}>
        <div className="ThemeForm">
          <Form
            form={form}
            name="evntForm"
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            layout="horizontal"
            colon={false}
            onFinish={onFinish}
            size="large"
          >
            <Row gutter={24} justify="space-around" align="middle">
              <Col span={24}>
                <Form.Item
                  name="LID"
                  label="Line"
                  rules={[
                    {
                      required: true,
                      message: "Please select a line",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    placeholder="Select a person"
                    optionFilterProp="children"
                    filterOption={(input, option) => {
                      return (
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      );
                    }}
                  >
                    {AuditLines.data.map((opt, key) => {
                      return (
                        <Select.Option key={"lines_" + key} value={opt.id}>
                          {opt.name}
                        </Select.Option>
                      );
                    })}
                  </Select>
                </Form.Item>
                <Form.Item
                  name="TYP"
                  label="Type"
                  rules={[
                    {
                      required: true,
                      message: "Please select a type",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    placeholder="Select a type"
                    optionFilterProp="children"
                    onChange={fetchSubType}
                    filterOption={(input, option) => {
                      return (
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      );
                    }}
                  >
                    {AuditType.data.map((opt, key) => {
                      return (
                        <Select.Option key={"type_" + key} value={opt.id}>
                          {opt.name}
                        </Select.Option>
                      );
                    })}
                  </Select>
                </Form.Item>
                <Form.Item
                  name="SUBTYP"
                  label="Sub-Type"
                  rules={[
                    {
                      required: true,
                      message: "Please select a sub-type",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    placeholder="Select a sub-type"
                    optionFilterProp="children"
                    filterOption={(input, option) => {
                      return (
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      );
                    }}
                  >
                    {AuditSubType.data.map((opt, key) => {
                      return (
                        <Select.Option key={"subtype_" + key} value={opt._id}>
                          {opt.SUBTYP}
                        </Select.Option>
                      );
                    })}
                  </Select>
                </Form.Item>
                <Form.Item
                  name="Status"
                  label="Status"
                  placeholder="Select a Status"
                  rules={[{ required: true }]}
                >
                  <Select
                    placeholder="Please select a status"
                    optionLabelProp="label"
                  >
                    <Select.Option key={"status_O"} value="O" label="Open">
                      <div
                        style={{
                          borderLeft: "5px solid",
                          borderColor: "#e74c3c",
                          paddingLeft: "10px",
                        }}
                      >
                        Open
                      </div>
                    </Select.Option>
                    <Select.Option key={"status_C"} value="C" label="Close">
                      <div
                        style={{
                          borderLeft: "5px solid",
                          borderColor: "#2ecc71",
                          paddingLeft: "10px",
                        }}
                      >
                        Close
                      </div>
                    </Select.Option>
                    <Select.Option key={"status_H"} value="H" label="Hold">
                      <div
                        style={{
                          borderLeft: "5px solid",
                          borderColor: "#3498db",
                          paddingLeft: "10px",
                        }}
                      >
                        Hold
                      </div>
                    </Select.Option>
                    <Select.Option key={"status_X"} value="X" label="Cancelled">
                      <div
                        style={{
                          borderLeft: "5px solid",
                          borderColor: "#ecf0f1",
                          paddingLeft: "10px",
                        }}
                      >
                        Cancelled
                      </div>
                    </Select.Option>
                  </Select>
                </Form.Item>
                <Form.Item
                  name="Auditor"
                  label="Auditor"
                  rules={[
                    {
                      required: true,
                      message: "Please select a Auditor",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    placeholder="Select a Auditor"
                    optionFilterProp="children"
                    filterOption={(input, option) => {
                      return (
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      );
                    }}
                  >
                    {AuditUsers.data.map((opt, key) => {
                      return (
                        <Select.Option key={"auditor_" + key} value={opt.id}>
                          {opt.name}
                        </Select.Option>
                      );
                    })}
                  </Select>
                </Form.Item>
                <Form.Item
                  name="Auditee"
                  label="Auditee"
                  rules={[
                    {
                      required: true,
                      message: "Please select a Auditee",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    placeholder="Select a Auditee"
                    optionFilterProp="children"
                    filterOption={(input, option) => {
                      return (
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      );
                    }}
                  >
                    {AuditUsers.data.map((opt, key) => {
                      return (
                        <Select.Option key={"auditee_" + key} value={opt.id}>
                          {opt.name}
                        </Select.Option>
                      );
                    })}
                  </Select>
                </Form.Item>
                <Form.Item
                  name="Team"
                  label="Team"
                  rules={[
                    {
                      required: true,
                      message: "Please select a Team",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    placeholder="Select a Team"
                    mode="multiple"
                    optionFilterProp="children"
                    filterOption={(input, option) => {
                      return (
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      );
                    }}
                  >
                    {AuditUsers.data.map((opt, key) => {
                      return (
                        <Select.Option key={"auditee_" + key} value={opt.id}>
                          {opt.name}
                        </Select.Option>
                      );
                    })}
                  </Select>
                </Form.Item>

                {/* <Form.Item
                                    name="AuditDt"
                                    label="Date"
                                    placeholder="Select a Date"
                                    rules={[{ required: true }]}
                                >
                                    <DatePicker className="gx-mb-3 gx-w-100" placeholder="Select a Date" />
                                </Form.Item> */}
                <Form.Item
                  name="Search"
                  label="Search Date"
                  placeholder="Select a Date"
                  rules={[{ required: true }]}
                >
                  <DatePicker.RangePicker
                    className="gx-mb-3 gx-w-100"
                    placeholder={["Start Date", "End Date"]}
                  />
                </Form.Item>
                <Form.Item className="formBtnGroup" label=" " colon={false}>
                  <Button
                    style={{ textAlign: "center" }}
                    type="primary"
                    htmlType="submit"
                    className="login-form-button gx-mt-1 bigBtn"
                    disabled={state.disabledBtn}
                  >
                    {"Search"}
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    </>
  );
};

export default SearchAudit;
